import { alterDate, getISODate, stringToDate } from '@hc-frontend/utils'
import { getCoverageType, productNames } from './getCoverageType'
import { getCarrierName } from '../utils'

function makePayloadAddon({ state, plan, leadId, opportunityId }) {
  const isTest = String(state.hcStorage.agent_id).includes('TEST') ? 'Yes' : 'No'

  const carrier = state.carriers
    ? state.carriers[plan.carrierId] && state.carriers[plan.carrierId].name
    : ''
  const premium =
    plan.durations && plan.durations.length > 0 ? plan.durations[0].monthly.premium : ''
  const fees =
    plan.durations && plan.durations.length > 0
      ? plan.durations[0].monthly.fees
      : undefined
  let fee = plan.feeInfo && plan.feeInfo.fees.subscriptionFee

  if (fees && !fee) {
    for (let i = 0; i < fees.length; i++) {
      if (fees[i].name === 'subscription') {
        fee = fees[i].value
      }
    }
  }

  const data = {
    idLead: leadId,
    header: {
      isATest__c: isTest,
      planId: plan.planId,
      planName: plan.planName,
      coverageType: getCoverageType(productNames[plan.productId]),
      product: getCoverageType(productNames[plan.productId]),
      carrier: getCarrierName(plan.carrierName || carrier || ''),
      placement: state.hcStorage.placement,
      monthlyCost: plan.premium || premium,
      oneTimeFee: fee || '',
      PolicyIssued__c: 'Yes',
      endDate: getISODate(
        alterDate({
          date: stringToDate(state.hcStorage.sdate || new Date()),
          days: 30
        })
      ),
      leadType: 'U65'
    }
  }

  if (state.hcStorage.sdate) {
    data.header['sdate'] = getISODate(stringToDate(state.hcStorage.sdate))
  }

  if (opportunityId) {
    data['idOpportunity'] = opportunityId
  }

  return data
}

export default makePayloadAddon
